import { createContext } from "react";

export type NotificationContextProps = {
  connected: boolean;
};

const NotificationContext = createContext({} as NotificationContextProps);

export default NotificationContext;
